import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../store/hooks';
import { CaretRight } from 'phosphor-react';
import { Report, Report as ReportsTypes } from '../Utilis/Types/Report';
import { createNotification } from '../store/notifications/notification-slice';
import { ReportService } from '../Service/ReportService';
import { useSidebarExtension } from '../context/SidebarExtensionProvider/useSidebarExtension';
import { ReportCategory } from '../Utilis/Types/Report';
import { Document } from '../components/Document';
import { Loading } from '../components/Loading';
import { EmptyList } from '../components/EmptyList';
import axios from 'axios';
import { Buffer } from 'buffer';

const reportCategories = {
  [ReportCategory.MASTER_TAX_PLAN]: 'Master Tax Plan',
  [ReportCategory.MASTER_FINANCIAL_PLAN]: 'Master Financial Plan',
  [ReportCategory.REDTAIL_DOCUMENT]: 'Other Reports',
};

const Reports = () => {
  const [reportCategory, setReportCategory] = useState<ReportCategory>(
    ReportCategory.MASTER_TAX_PLAN
  );
  const [reports, setReports] = useState<ReportsTypes[]>([]);
  const appDispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState({
    reports: false,
    download: false,
  });
  const { openSidebarExtension, closeSidebarExtension } = useSidebarExtension();

  useEffect(() => {
    const types = Object.values(ReportCategory);

    const sidebar = types.map(item => ({
      title: reportCategories[item],
      selected: reportCategory === item,
      endIcon: <CaretRight />,
      onClick: () => setReportCategory(item),
    }));

    openSidebarExtension(sidebar);

    return () => closeSidebarExtension();
  }, [reportCategory]);

  useEffect(() => {
    getReports();
  }, [reportCategory]);

  const getReports = async () => {
    setIsLoading(prev => ({ ...prev, reports: true }));
    try {
      const response = await ReportService.getUserReports(reportCategory);
      setReports(response.data);
    } catch (error) {
      appDispatch(
        createNotification({
          type: 'error',
          message: 'Something went wrong , try again later!',
        })
      );
    } finally {
      setIsLoading(prev => ({ ...prev, reports: false }));
    }
  };

  const downloadReport = async (report: Report) => {
    if (report.category === ReportCategory.REDTAIL_DOCUMENT) {
      const result = await ReportService.downloadReport(report.id);

      const blob = new Blob([Buffer.from(result.data.buffer)], {
        type: 'application/pdf',
      });

      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = report.title + '.pdf';
      link.click();

      return;
    }

    const url = new URL(report.src!);
    const file = url.pathname.split('/').pop();
    const filename = file!.split('.')[0];

    const link = document.createElement('a');

    axios
      .get(report.src!, {
        responseType: 'blob',
      })
      .then(res => {
        link.href = URL.createObjectURL(res.data);
        link.download = filename;
        link.click();
      })
      .finally(() => {
        link.remove();
      });
  };

  const showReport = async (report: Report) => {
    let src = report.src!;

    if (report.category === ReportCategory.REDTAIL_DOCUMENT) {
      const result = await ReportService.downloadReport(report.id);

      const blob = new Blob([Buffer.from(result.data.buffer)], {
        type: 'application/pdf',
      });

      src = URL.createObjectURL(blob);
    }
    window.open(src);
  };

  return (
    <Box sx={{ padding: '32px' }}>
      <Loading isLoading={isLoading.reports}>
        <Typography
          color={'#202A2D'}
          fontSize={'20px'}
          fontWeight={'600'}
          lineHeight={'24px'}
          sx={{
            marginBottom: '24px',
          }}
        >
          {reportCategories[reportCategory]}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            paddingBottom: '20px',
          }}
        >
          {!!reports.length ? (
            reports.map((report: Report, i: number) => {
              return (
                <Document
                  key={i}
                  title={report.title}
                  uploadedAt={report.createdAt}
                  onDisplay={() => showReport(report)}
                  onDownload={() => downloadReport(report)}
                  display
                  download
                  square
                />
              );
            })
          ) : (
            <EmptyList
              message={`No ${reportCategories[reportCategory]} report found!`}
            />
          )}
        </Box>
      </Loading>
    </Box>
  );
};

export default Reports;
